// extracted by mini-css-extract-plugin
export var button = "_ms-2";
export var card = "_ms-0";
export var closeButtonContainer = "_ms-3";
export var iconContainer = "_ms-1";